<span class="badge"
    [class.badge-success]="isSituacaoAtivo()"
    [class.badge-danger]="isSituacaoInativo()">
    {{situacao | mercadoSituacao}}
</span>